function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.33333333,13.6190417 C7.76670833,13.6190417 6.29054167,13.33725 4.99404167,12.839875 C3.68675,13.86275 2.08283333,14.4860417 0.378875,14.6647083 C0.366555857,14.6659992 0.354178253,14.6666667 0.341791667,14.6666667 C0.186125,14.6666667 0.0455,14.5625833 0.00775,14.414125 C-0.0330833333,14.2490833 0.09475,14.1475 0.221333333,14.0264167 C0.847041667,13.4247917 1.60558333,12.9518333 1.90225,10.9307083 C0.708958333,9.78691667 0,8.35925 0,6.80954167 C0,3.04833333 4.17904167,-3.73034936e-14 9.33333333,-3.73034936e-14 C14.487625,-3.73034936e-14 18.6666667,3.04829167 18.6666667,6.80954167 C18.6666667,10.573375 14.487625,13.6190417 9.33333333,13.6190417 Z M23.7944583,18.084625 C23.2134583,17.5376667 22.5090833,17.1077083 22.233625,15.2703333 C25.100625,12.58 24.4074167,8.731375 20.663875,6.642625 C20.6651667,6.69820833 20.666625,6.75375 20.666625,6.80954167 C20.666625,11.9134167 15.2673333,15.8259583 8.82279167,15.6104583 C10.4111667,16.9005 12.739,17.7142917 15.3332917,17.7142917 C16.7880417,17.7142917 18.15875,17.458125 19.362625,17.0059583 C20.5765417,17.9358333 22.065875,18.5024583 23.6481667,18.664875 C23.8059167,18.6813333 23.9549583,18.5826667 23.99275,18.4370833 C24.0307083,18.2870417 23.912,18.1947083 23.7944583,18.084625 L23.7944583,18.084625 Z",
  id: "path-comments-2"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layouts",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Solid/comments",
  transform: "translate(0.000000, 0.438424)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-comments-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-comments-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDFA8-color",
  mask: "url(#mask-comments-2)",
  fill: "#242A42"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, -2.666667)",
  id: "Black"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 24,
  height: 24
})))));

function SvgComments2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Solid/comments@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments2);
export default __webpack_public_path__ + "static/media/comments-2.bdad1d8d.svg";
export { ForwardRef as ReactComponent };